import gates from "./gates.json";
import { defaultLocale, livingMapLang, type Locale } from "@/i18n/config";

// Base del mapa interactivo de la terminal (LivingMap).
const LIVINGMAP_BASE = "https://airportpanama.lmp.prod.livingmap.com";

// Las puertas de embarque están en el nivel 2 del mapa.
const GATES_FLOOR = 2;

const GATES = gates as Record<string, string>;

/**
 * Normaliza la puerta que viene del API ("105", " 105 ", "105A"…) a la llave
 * del JSON y devuelve el feature id del POI en LivingMap.
 */
export function lookupGateFeature(gate?: string | null): string | null {
  if (!gate) return null;
  const clean = gate.trim().toUpperCase();
  if (GATES[clean]) return GATES[clean];
  // El API de vuelos devuelve la puerta con prefijo ("G221"), y algunas traen
  // sufijo de letra; en ambos casos nos quedamos con los dígitos.
  const digits = clean.replace(/[^0-9]/g, "");
  return GATES[digits] ?? null;
}

const langParam = livingMapLang;

/** URL del mapa centrado en una sola puerta (POI). */
export function buildGatePoiUrl(feature: string, locale: Locale = defaultLocale) {
  return `${LIVINGMAP_BASE}/poi?feature=${feature}&floor=${GATES_FLOOR}&lang=${langParam(
    locale,
  )}#18/9.067801/-79.38642/119`;
}

/**
 * URL de la ruta paso a paso entre dos puertas.
 * Formato: /navigate/{origen}/{destino}/?floor=2
 */
export function buildGateRouteUrl(
  fromGate?: string | null,
  toGate?: string | null,
  locale: Locale = defaultLocale,
): string | null {
  const from = lookupGateFeature(fromGate);
  const to = lookupGateFeature(toGate);
  if (!from || !to || from === to) return null;
  return `${LIVINGMAP_BASE}/navigate/${from}/${to}/?floor=${GATES_FLOOR}&lang=${langParam(
    locale,
  )}`;
}

/**
 * Reescribe el parámetro `lang` de cualquier URL de LivingMap al idioma del
 * usuario. Las URLs de POI se pegan desde el visor, que las exporta siempre con
 * `lang=en-GB`; sin esto el mapa salía en inglés incluso navegando en español.
 */
export function withLivingMapLang(url: string, locale: Locale): string {
  return url.replace(/([?&]lang=)[^&#]*/, `$1${livingMapLang(locale)}`);
}
